/* eslint-disable */
/* tslint:disable */
/* auto-generated react proxies */
import { createReactComponent } from './react-component-lib';
export const FugroIcon = /*@__PURE__*/ createReactComponent('fugro-icon');
export const FugroList = /*@__PURE__*/ createReactComponent('fugro-list');
export const FugroListItem = /*@__PURE__*/ createReactComponent('fugro-list-item');
export const FugroLogo = /*@__PURE__*/ createReactComponent('fugro-logo');
export const FugroSearchInput = /*@__PURE__*/ createReactComponent('fugro-search-input');
export const FugroSideNavMenu = /*@__PURE__*/ createReactComponent('fugro-side-nav-menu');
export const FugroSideNavMenuGroup = /*@__PURE__*/ createReactComponent('fugro-side-nav-menu-group');
export const FugroSideNavMenuItem = /*@__PURE__*/ createReactComponent('fugro-side-nav-menu-item');
export const FugroSideNavMenuSubGroup = /*@__PURE__*/ createReactComponent('fugro-side-nav-menu-sub-group');
//# sourceMappingURL=components.js.map